export default __webpack_public_path__ + "static/Card4-650a3607f0bd851da8897a27a9e301b5.png";